// General Settings

export const version = 1.0;
export const clientName = 'Weekender Breaks USA';

export const env = 'PROD';

/* --------------------------------------------------- */

// Api Settings

export const devApiUrl = 'https://api.weekender-breaks.com';
export const stageApiUrl = 'https://api.weekender-breaks.com';
export const prodApiUrl = 'https://api.weekender-breaks.com/api';

/* --------------------------------------------------- */

// Domain Settings

export const stageUrl = 'viva-weekender-break-us-admin.stagelab.co.uk';
export const prodUrl = 'admin.weekender-breaks.com';

/* --------------------------------------------------- */

// Cloudinary Api Settings.
// Setup a Cloudinary account on behalf of the client.  Input the details here.

export const EAGER = [
    {
        width: 1000,
        height: 1000,
        crop: 'crop',
    },
];

export let cloudinaryApiKey = '394715672258859';
export let cloudinaryApiUploadPreset = 'efiw6rof';
export let cloudinarySecret = 'Seu-PbcKKbZ6YMQ9QEHLHfwiGk4';

if (window.location.hostname === stageUrl) {
    cloudinaryApiKey = '394715672258859';
    cloudinaryApiUploadPreset = 'efiw6rof';
    cloudinarySecret = 'Seu-PbcKKbZ6YMQ9QEHLHfwiGk4';
} else if (window.location.hostname === prodUrl) {
    cloudinaryApiKey = '';
    cloudinaryApiUploadPreset = '';
    cloudinarySecret = '';
}

/* --------------------------------------------------- */



// WEBPACK FOOTER //
// ./src/config/config.js